import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import {
  IAttachAuditionMedia,
  IAuditionAttachmentsPayload,
  IAuditionRequestPayload,
  IAuditionResponsePayload,
  IVerifyAudition,
  IVerifyAuditionResponse,
} from 'shared/interfaces/IAudition';
import { ISelfTapesScheduleResponse } from 'shared/interfaces/IAuditionSchedule';
import { GET_AUDITIONS } from 'shared/queries/audition.queries';
import { authToken } from 'shared/utils/authToken';

const { POST, GET, DELETE, PATCH } = useAxios();
export const auditionDao = () => {
  const { getAuthToken } = authToken();

  const getAudition = async (id: string) => {
    const response = await GET<ISelfTapesScheduleResponse>({
      url: `${ENDPOINTS.AUDITION_SCHEDULES}/${id}`,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
    return response.data;
  };

  const getAuditions = async (payload: IAuditionRequestPayload) => {
    const response = await POST<IAuditionResponsePayload>({
      url: ENDPOINTS.GRAPHQL,
      data: {
        query: GET_AUDITIONS,
        variables: { ...payload, phase: 'Submission' },
      },
    });
    return response.data;
  };

  const getAuditionAttachements = async (auditionID: string) => {
    const response = await GET<IAuditionAttachmentsPayload>({
      url: `${ENDPOINTS.AUDITION_SCHEDULES}/${auditionID}/medium_attachments`,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    return response.data;
  };

  const attachAuditionMedia = async (auditionID: string, payload: IAttachAuditionMedia) => {
    const response = await POST({
      url: `${ENDPOINTS.AUDITION_SCHEDULES}/${auditionID}/medium_attachments`,
      data: payload,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    return response.data;
  };

  const updateAuditionMedia = async (auditionID: string, medium_id: string, payload: IAttachAuditionMedia) => {
    const response = await PATCH({
      url: `${ENDPOINTS.AUDITION_SCHEDULES}/${auditionID}/medium_attachments/${medium_id}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    return response.data;
  };

  const deleteAuditionMedia = async (auditionID: string, mediumId: string) => {
    const response = await DELETE({
      url: `${ENDPOINTS.AUDITION_SCHEDULES}/${auditionID}/medium_attachments/${mediumId}`,
      headers: {
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });

    return response.data;
  };

  const verifyAudition = async (payload: IVerifyAudition) => {
    //get request to verify the audition with payload
    const response = await GET<IVerifyAuditionResponse>({
      url: `${ENDPOINTS.VERIFY_AUDITION}`,
      params: payload,
    });

    return response.data;
  };

  return {
    updateAuditionMedia,
    verifyAudition,
    getAudition,
    getAuditionAttachements,
    getAuditions,
    attachAuditionMedia,
    deleteAuditionMedia,
  };
};
